import * as GriffinPhone from 'griffin-paypal/phone';
import { store } from '../../../../framework/store/configureStore';

export const phoneNormalize = (value, previousValue) => {
    //allow empty strings, but return right away since there's not way it can be normalized
    if (!value) {
        return value;
    }

    //prevent first two digits from being 00
    if (value.substring(0, 2) === '00') {
        return previousValue;
    }

    //allow only digits and spaces
    const pattern = /^[0-9 ]+$/;
    if (!pattern.test(value)) {
        return previousValue;
    }

    return value;
};

export const isPhoneValid = (msg) => (value) => {
    try {
        formatNumber(value);
        return;
    } catch (e) {
        return {
            msg,
            className: 'hasError'
        };
    }
};

/*
  Use griffin to normalize the number.  Will throw an error if input is bad
 */
export function formatNumber(value) {
    const storeState = store.getState();
    const griffinPhoneHandler = GriffinPhone.createHandler(storeState.serverData.localityMetadata);
    const normalizedPhoneNumber = griffinPhoneHandler.normalizePhoneNumber(value);
    return griffinPhoneHandler.formatPhoneNumber(normalizedPhoneNumber);

}

